export default __webpack_public_path__ + "assets/img_webp/anniversary_n_btn_022.png";